import apiService from '@/api/apiService';

export const getMyPermissions = async () => {
    const url = '/api/admin/manager/permissions';

    return apiService.GET(url);
};
